import React from 'react';

import { Typography } from 'ha/ui/next/Typography';
import { withIntl, IntlProps } from 'ha/i18n';
import * as SearchFilters from 'ha/types/SearchFilters';
import RadioGroup from 'ha/components/next/FormFields/RadioGroup';

interface Props {
  furniture: SearchFilters.FurnitureFilterValue;
  onChange: (value: SearchFilters.FurnitureFilterValue) => void;
}

interface FurnitureOption {
  value: SearchFilters.FurnitureValue;
  title: string;
  dataTestLocator?: string;
}

export const FurnitureFilter: React.FC<Props & IntlProps> = ({
  furniture,
  onChange,
  intl: { T },
}) => (
  <React.Fragment>
    <Typography.ParagraphTitle data-test-locator="FurnitureFilter Title">
      {T('Furniture')}
    </Typography.ParagraphTitle>

    <RadioGroup
      input={{
        value: furniture as string,
        onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
          onChange(e.target.value as SearchFilters.FurnitureFilterValue),
      }}
      options={
        [
          {
            value: SearchFilters.FurnitureValue.FURNISHED,
            title: T('Furnished'),
            dataTestLocator: 'Filter Furnished',
          },
          {
            value: SearchFilters.FurnitureValue.UNFURNISHED,
            title: T('Unfurnished'),
            dataTestLocator: 'Filter Unfurnished',
          },
        ] as FurnitureOption[]
      }
      data-test-locator="FurnitureFilter Controls"
    />
  </React.Fragment>
);

export default withIntl(FurnitureFilter);
